import { useLayoutEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { motion } from "motion/react";
import { useReducedMotion } from "../units/useReducedMotion.js";
import "./motion.css";

/** Presentation only: balances have already been settled by the server. */
export function RewardFlight({ origin, target, children }: { origin: string; target: string; children: ReactNode }) {
  const reduced = useReducedMotion();
  const [points, setPoints] = useState<{ x: number; y: number; toX: number; toY: number } | null>(null);
  useLayoutEffect(() => {
    if (reduced) return;
    const source = document.querySelector(origin)?.getBoundingClientRect();
    const destination = document.querySelector(target)?.getBoundingClientRect();
    if (source?.width && destination?.width) setPoints({ x: source.x + source.width / 2 - 14, y: source.y + source.height / 2 - 14, toX: destination.x + destination.width / 2 - 14, toY: destination.y + destination.height / 2 - 14 });
  }, [origin, target, reduced]);
  if (reduced || !points) return null;
  return createPortal(<motion.div aria-hidden className="reward-flight" initial={{ x: points.x, y: points.y, opacity: 0 }} animate={{ x: [points.x, (points.x + points.toX) / 2, points.toX], y: [points.y, Math.min(points.y, points.toY) - 42, points.toY], opacity: [0, 1, 0], scale: [0.7, 1.15, 0.6] }} transition={{ duration: 0.85, delay: 0.65, ease: "easeInOut" }}>{children}</motion.div>, document.body);
}
